import { jsx as L } from "react/jsx-runtime";
const e = ({
  size: r
}) => {
  switch (r) {
    case "sm":
      return /* @__PURE__ */ L(
        "path",
        {
          d: "M4.2675 12.4366L3.565 11.7341L7.29834 8.00078L3.565 4.26744L4.2675 3.56494L8.00084 7.29827L11.7342 3.56494L12.4367 4.26744L8.70334 8.00078L12.4367 11.7341L11.7342 12.4366L8.00084 8.70328L4.2675 12.4366Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ L(
        "path",
        {
          d: "M6.4 18.6525L5.34625 17.5987L10.9463 11.9987L5.34625 6.39872L6.4 5.34497L12 10.945L17.6 5.34497L18.6538 6.39872L13.0538 11.9987L18.6538 17.5987L17.6 18.6525L12 13.0525L6.4 18.6525Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ L(
        "path",
        {
          d: "M5.33479 15.5447L4.45667 14.6665L9.12333 9.99987L4.45667 5.3332L5.33479 4.45508L10.0015 9.12175L14.6681 4.45508L15.5462 5.3332L10.8796 9.99987L15.5462 14.6665L14.6681 15.5447L10.0015 10.878L5.33479 15.5447Z",
          fill: "currentColor"
        }
      );
  }
}, l = ({
  size: r
}) => {
  switch (r) {
    case "sm":
      return /* @__PURE__ */ L(
        "path",
        {
          d: "M4.26457 12.7934L3.20374 11.7326L6.93707 7.99924L3.20374 4.26591L4.26457 3.20508L7.9979 6.93841L11.7312 3.20508L12.7921 4.26591L9.05874 7.99924L12.7921 11.7326L11.7312 12.7934L7.9979 9.06008L4.26457 12.7934Z",
          fill: "currentColor"
        }
      );
    case "lg":
      return /* @__PURE__ */ L(
        "path",
        {
          d: "M6.39374 19.1926L4.80249 17.6013L10.4025 12.0013L4.80249 6.40131L6.39374 4.81006L11.9937 10.4101L17.5937 4.81006L19.185 6.40131L13.585 12.0013L19.185 17.6013L17.5937 19.1926L11.9937 13.5926L6.39374 19.1926Z",
          fill: "currentColor"
        }
      );
    case "md":
    default:
      return /* @__PURE__ */ L(
        "path",
        {
          d: "M5.32812 15.9903L4.00208 14.6643L8.66874 9.99759L4.00208 5.33092L5.32812 4.00488L9.99478 8.67155L14.6615 4.00488L15.9875 5.33092L11.3208 9.99759L15.9875 14.6643L14.6615 15.9903L9.99478 11.3236L5.32812 15.9903Z",
          fill: "currentColor"
        }
      );
  }
}, c = ({
  size: r = "md",
  weight: t = "default"
}) => {
  switch (t) {
    case "bold":
      return /* @__PURE__ */ L(l, { size: r });
    case "book":
    case "default":
      return /* @__PURE__ */ L(e, { size: r });
  }
};
export {
  c as default
};
//# sourceMappingURL=DIconClose.js.map
